'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useAtom } from 'jotai'
import { shopId } from './stores/storage'

import localFont from 'next/font/local'
const font = localFont({ src: '../public/fonts/hanachi.ttf' })

export default function Index() {
  const [currentShop, setCurrentShop] = useAtom(shopId)
  return (
    <main>
      <div className={`h-screen ${font.className}`} style={{ backgroundImage: "url('/images/darkback.png')" }}>
        <div className="flex items-center place-content-center h-[40vh]">
          <div className="flex bg-white rounded-3xl items-center justify-center p-2">
            <Image width={250} height={250} src="/images/logo_new.png" alt="logo" className='px-5 p-2' />
          </div>
        </div>
        <div className="flex flex-col items-center place-content-around h-[55vh] pb-2">
          <div className="grid gap-y-4 w-full">
            <div className="flex items-center px-10">
              <Link
                onClick={() => setCurrentShop(1)}
                href="/home"
                className="btn flex place-content-between content-center font-thin w-full h-full text-[8vw] rounded-full p-1"
              >
                <div className="bg-[#EADF00] rounded-full">
                  <Image width={35} height={35} src="/images/fastfood.png" alt="fastfood" className="m-1" />
                </div>
                <p className="pl-5 pt-1">منو لانژ</p>
              </Link>
            </div>
            <div className="flex items-center px-10">
              <Link
                onClick={() => setCurrentShop(2)}
                href="/home"
                className="btn flex place-content-between content-center font-thin w-full h-full text-[8vw] rounded-full p-1"
              >
                <p className="pr-5 pt-3">منو کافه</p>
                <div className="bg-[#EADF00] rounded-full">
                  <Image width={35} height={35} src="/images/cafe.png" alt="fastfood" className="m-1" />
                </div>
              </Link>
            </div>
            <div className="flex items-center px-10">
              <Link
                onClick={() => setCurrentShop(26)}
                href="/home"
                className="btn flex place-content-between content-center font-thin w-full h-full text-[8vw] rounded-full p-1"
              >
                <div className="bg-[#EADF00] rounded-full">
                  <Image width={35} height={35} src="/images/egg.svg" alt="egg" className="m-1" />
                </div>
                <p className="pl-5 pt-1">منو صبحانه</p>
              </Link>
            </div>
            <div className="flex items-center px-10">
              <Link
                onClick={() => setCurrentShop(42)}
                href="/home"
                className="btn flex place-content-between content-center font-thin w-full h-full text-[8vw] rounded-full p-1"
              >
                <p className="pr-5 pt-3">منو سنتی</p>
                <div className="bg-[#EADF00] rounded-full">
                  <Image width={35} height={35} src="/images/categories/food_line.png" alt="fastfood" className="m-1" />
                </div>
              </Link>
            </div>
          </div>
          <div className="grid gap-y-5 mt-10">
            <p className="text-white text-base">دزفول بلوار پیام آوران نبش بلوار ملاصدرا نرسیده به میدان ناهیدی</p>
            <p className="text-white text-center text-base">تلفن ها: ۴۲۵۵۲۶۸۸ و ۴۲۵۵۲۶۸۹</p>
          </div>
          <div className="flex content-center place-content-center gap-10">
            <a href="tel:06142552688">
              <Image width={50} height={50} src="/images/phone1.png" alt="phone" className="rounded-2xl bg-[#EADF00] p-3" />
            </a>
            <a href="https://www.instagram.com/limoo.fastfood?igsh=Z3JnM2VxdDUzZDM2&utm_source=qr">
              <Image width={50} height={50} src="/images/instagram1.png" alt="instagram" className="rounded-2xl bg-[#EADF00] p-3" />
            </a>
          </div>
        </div>
      </div>
    </main>
  )
}
